import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendProductOrder,
} from "node-library/dist/portal";

import OrderCell from "./orderCell";

interface Props {
	orders: Array<FrontendProductOrder>;
	user: FrontendUserInfo | undefined;
	discardUnstartedOrder: (order: FrontendProductOrder) => void;
	goToEditOrderPage: (order: FrontendProductOrder) => void;
	goToViewOrderDetails: (order: FrontendProductOrder) => void;
	viewOrderCOC: (order: FrontendProductOrder) => void;
	viewResult: (order: FrontendProductOrder) => void;

	setDiscardOrderConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function ViewOrdersTable(props: Props) {
	const { t: translation } = useTranslation();

	const {
		orders,
		goToViewOrderDetails,
		goToEditOrderPage,
		discardUnstartedOrder,
		viewOrderCOC,
		setDiscardOrderConfirmOpen,
		setProceedAction,
		viewResult,
	} = props;

	const sampleCellss: Array<React.ReactNode> = orders
		? orders.map((order: FrontendProductOrder, index: number) => {
				return (
					<OrderCell
						key={order.orderId}
						order={order}
						user={props.user}
						viewOrderCOC={() => {
							viewOrderCOC(order);
						}}
						goToViewOrderDetails={() => goToViewOrderDetails(order)}
						discardUnstartedOrder={() => {
							setProceedAction(() => () => discardUnstartedOrder(order));
							setDiscardOrderConfirmOpen(true);
						}}
						editOrder={() => goToEditOrderPage(order)}
						viewResult={() => viewResult(order)}
					/>
				);
		  })
		: [];

	return <div className="view-order-grid-table">{sampleCellss}</div>;
}
